<template>
  <div class="row">
    <div class="col-lg-12 profile-details">
      <h2 class="cp-title">Your Profile</h2>

      <form @submit="updateProfile">
        <div class="form-group">
          <label>Name<span class="required">*</span></label>
          <input
            type="text"
            ref="name"
            v-model="profile.name"
            class="form-control"
            value="Md. Minul Islam"
          />
        </div>

        <div class="form-group">
          <label>Mobile<span class="required">*</span></label>
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <span class="input-group-text">+88</span>
            </div>
            <input
              readonly
              type="text"
              ref="mobile"
              v-model="profile.mobile"
              class="form-control"
              placeholder="Enter your mobile number"
              autocomplete="off"
            />
          </div>
        </div>

        <div class="form-group">
          <label>Email</label>
          <input
            type="email"
            ref="email"
            v-model="profile.email"
            class="form-control"
            value="e.g. engrminul@gmail.com"
          />
        </div>

        <div class="form-group">
          <button type="submit" class="btn btn-primary">
            Update
          </button> 

        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errors: [],
      profile: null,
    };
  },
  methods: {
    getProfile() {
      this.$authHttp
        .get("customer-profile")
        .then(response => {
          this.profile = response.data.data;
          console.log(this.profile)
        })
        .catch(e => {
          console.log(e);
        });
    },
    updateProfile: function(e) {
      e.preventDefault();
      if (!this.profile.name) {
        this.$refs.name.focus();
        this.flashMessage.error({ message: "Name required" });
        return false;
      }

      this.$authHttp
        .post("customer-profile-update", this.profile)
        .then(response => {
          if(response.data.status){
          localStorage.setItem("name", this.profile.name);
          localStorage.setItem("email", this.profile.email);
            this.flashMessage.success({
              message: response.data.message
            });
          }else{
              this.flashMessage.success({
                message: response.data.message
              });
          }
        })
        .catch(error => {
              this.flashMessage.error({
              message: error.response.data.message
            });
        });
    }
  },
  mounted(){
    this.getProfile();
  }
};
</script>

<style></style>
